import { lazy, Suspense } from 'react';

import type { RouteViewType } from '@/types';

import IncidentDetails from '@/components/Incidents/incident-details';
import RouteIncidentsList from '@/components/routes/route-incidents-list';
import RouteList from '@/components/routes/route-list';
import RouteDetailsLoader from '@/components/shared/loader/route-details-loader';
import { INCIDENT_DETAILS, INCIDENTS_LIST, ROUTE_DETAILS } from '@/utils/constants';

const LazyRouteDetails = lazy(() => import('@/components/routes/route-details'));

interface RouteContentRendererProps {
  viewType: RouteViewType;
  onSelectReservationTab: (newTab: string) => void;
  selectedTab: string;
  isAllExpanded: boolean;
  onAllExpand: (isAllExpanded: boolean) => void;
  currentLineNumber: string | null;
}

const RouteContentRenderer = ({
  viewType,
  onSelectReservationTab,
  selectedTab,
  isAllExpanded,
  onAllExpand,
  currentLineNumber,
}: RouteContentRendererProps) => {
  if (viewType === INCIDENTS_LIST && currentLineNumber) {
    return <RouteIncidentsList currentLineNumber={currentLineNumber} />;
  }

  if (viewType === INCIDENT_DETAILS) {
    return <IncidentDetails />;
  }

  if (viewType === ROUTE_DETAILS) {
    return (
      <div className="h-full flex flex-col">
        <Suspense fallback={<RouteDetailsLoader />}>
          <LazyRouteDetails
            onSelectReservationTab={onSelectReservationTab}
            selectedTab={selectedTab}
            isAllExpanded={isAllExpanded}
            onAllExpand={onAllExpand}
          />
        </Suspense>
      </div>
    );
  }

  return <RouteList />;
};

export default RouteContentRenderer;
